import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  Input,
} from '@angular/core';
import { Store } from '@ngxs/store';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'goa-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  @Input() caption = '';
  @Input() subCaption = '';

  isDesktop = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isDesktop = this.$window.innerWidth > 400;
  }

  constructor(private store: Store, @Inject('window') private $window: Window) {
    this.onResize();
  }
}
